import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContextScreenComponent } from './context_screen.component';
import { ContextScreenUpdateComponent } from './context_update_screen.component';
import { AuthGuard, SharedModule } from '../../../shared';
import { ContextScreenService } from './context.service';

const contextScreenRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/dfb/config/context-screen/create',
    component: ContextScreenComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  },{
    path: 'setting/dfb/config/context-screen/update',
    component: ContextScreenUpdateComponent,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [  
    SharedModule,
    contextScreenRouting,
    NgbModule
  ],
  declarations: [
    ContextScreenComponent,
    ContextScreenUpdateComponent
  ],
  providers: [
 ContextScreenService
  ],
})
export class ContextScreenModule {}




// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/context_screen/context.module.ts